export default "__VITE_PUBLIC_ASSET__6ca993b1__"